import { useCallback, useEffect, useState } from 'react';
import type { Panel } from '@bccomms/shared';
import { session } from '../../lib/session';

export function usePanels(): [Panel[], () => Promise<void>] {
  const [panels, setPanels] = useState<Panel[]>([]);
  const refresh = useCallback(async () => {
    try {
      setPanels((await session.admin('admin.panels.list', {})) as Panel[]);
    } catch (err) {
      console.warn('panels.list failed', err);
    }
  }, []);
  useEffect(() => {
    void refresh();
  }, [refresh]);
  return [panels, refresh];
}
